import { render, staticRenderFns } from "./CandidateCourse.vue?vue&type=template&id=202ff07e&"
import script from "./CandidateCourse.vue?vue&type=script&lang=js&"
export * from "./CandidateCourse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports